import { render, staticRenderFns } from "./DashboardDaeeCard2.vue?vue&type=template&id=65ecedf6"
import script from "./DashboardDaeeCard2.vue?vue&type=script&lang=js"
export * from "./DashboardDaeeCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports